import { FcsFlag } from "../unleash";

class QuarantineInfoFlag extends FcsFlag.JSONFlag {
  isEnabled() {
    return FcsFlag.isEnabled(this.name);
  }
}

export const FlagsQuarantine = {
  create_shipment_quarantine_info: new QuarantineInfoFlag({
    title: "Wajib Sertifikat Karantina",
    body: "Tanpa sertifikat karantina, pengiriman paket dapat ditolak atau ditahan. Cek {example_link} atau {guide_link}",
    logo: {
      url: "",
      alt: "Peringatan sertifikat karantina",
    },
    links: {
      example_link: {
        label: "Contoh surat karantina",
        url: "",
      },
      guide_link: {
        label: "Panduan melampirkan pada paket",
        url: "",
      },
    },
  }),
};

export function initFlagsQuarantine() {
  FcsFlag.register("website", FlagsQuarantine);
}
